import * as axios from 'axios';
import * as Oidc from 'oidc-client-ts';

const opt = window.TgLoginOptions || {};

const accountBaseUrl = opt.baseUrl || 'https://account.tenen.local';
const siteId = opt.siteId || 50;
const subfolder = opt.subfolder || '';
const subfolderName = subfolder == '' ? '' : subfolder.substring(1);
const challengeUrl = opt.challengeUrl || 'tg_challenge';
const fbRedirectUrl = opt.fbRedirectUrl || subfolder + '/tg_auth_done';
const signOutUrl = opt.signOutUrl || 'tg_signout';
const clientId = opt.clientId + '_js';
const postLoginHook = opt.postLoginHook || (() => {});
const postSignOutHook = opt.postSignOutHook || (() => {});

let silentIframe;
let popupWindow;

let oidcSigninWasCalled = false;

window.Oidc = Oidc;

const settings = {
    authority: opt.baseUrl,
    client_id: clientId,
    response_type: 'code',
    scope: 'openid profile email account.manage',
    
    redirect_uri: window.location.origin + subfolder + '/authorization-code/js_callback',
    silent_redirect_uri: window.location.origin + subfolder + '/authorization-code/js_callback',
    automaticSilentRenew: true,

    filterProtocolClaims: true,
    loadUserInfo: true
};

const mgr = new Oidc.UserManager(settings);

//Cookie management
const hintCookie = "TgAccountHint" + subfolderName;
const setCookie = (name,value) => {
    var path = subfolder == '' ? '/' : subfolder;
    document.cookie = `${name}=${value}; path=${path}`;
};
const getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
};
const eraseCookie = (name) => {   
    var path = subfolder == '' ? '/' : subfolder;
    document.cookie = `${name}=; Path=${path}; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
};
//Hint is a special cookie helping SSR to prerender AUTH state of components
const ensureHintExists = (force) => {
    if (!getCookie(hintCookie) || force) {
        return getUser().then(r => {
            setCookie(hintCookie, encodeURIComponent(btoa(encodeURIComponent(`${r.profile.given_name}|${r.profile.family_name}`))));
        });
    }
};
const eraseHint = () => {
    if (getCookie(hintCookie)) {
        eraseCookie(hintCookie);
    }
};
//end of cookie management

const ax = axios.create({
    baseURL: `${accountBaseUrl}/api/`,
    timeout: 60000, //1 min
    withCredentials: true
});

const fail = (errorMessage) => {
    console.log(errorMessage);
    return Promise.reject({
        errorCode: 0,
        errorMessage
    });
};

const failWithBackend = (data) => {
    console.log(data.errorMessage);
    return Promise.reject(data);
};

let resolveAuth;
let rejectAuth;

const tryInvokeAuthPromise = (func) => {
    if (!func) {
        console.log('TgLogin: auth promise is broken');
    }

    func();
}

window.addEventListener('message', function(e){
    if (e.origin !== location.origin) {
        return;
    }
    
    if (e.source === popupWindow) {
        popupWindow.close();
    }
    
    if ((silentIframe && e.source === silentIframe.contentWindow) ||
        (e.source === popupWindow)) {
        if (e.data.indexOf('access_denied') < 0) {
            tryInvokeAuthPromise(resolveAuth);
        }
        else {
            tryInvokeAuthPromise(rejectAuth);
        }
    }
}, false);

const isLoggedInAuthority = () => {
    return ax.get(`islogged`)
        .then(res => res.data)
        .catch(() => fail('TgLogin.isLoggedIn: Backend error'));
};

const ensureSessionSync = (isLoggedOnAuthority) => {
    return axios.get('api/account/islogged')
        .catch(() => ({ data: false }))
        .then(res => {
            if (isLoggedOnAuthority && !res.data) {
                return silentRefresh();
            }
            if (!isLoggedOnAuthority && res.data) {
                return new Promise((resolve) => {
                    resolveAuth = () => {
                        resolve();
                    };
                    ensureSilentIFrameExists();
                    silentIframe.src = signOutUrl;
                });
            }
        });
};

const isLoggedIn = () => {
    if (oidcSigninWasCalled) {
        return mgr.getUser().then(res => (res && res.access_token) ? true : false);
    }
    else {
        console.log('TgLogin: init...');
        return isLoggedInAuthority().then(isLogged => {
            if (isLogged) {
                return mgr.signinSilent().then(() => {
                    oidcSigninWasCalled = true;
                    return ensureSessionSync(true).then(() => ensureHintExists()).then(() => true);
                })
                .catch(() => cleanFrontEndUserOnStart());
            }

            return cleanFrontEndUserOnStart();
        });
    }
};

const cleanFrontEndUserOnStart = () => mgr.removeUser()
    .then(() => {
        oidcSigninWasCalled = true;
        return ensureSessionSync(false).then(() => eraseHint()).then(() => false);
    });

const ensureSilentIFrameExists = () => {
    if (!silentIframe) {
        silentIframe = document.createElement('iframe');
        silentIframe.style.display = 'none';
        document.body.appendChild(silentIframe);
    }
};

const silentRefresh = () => {
    return new Promise((resolve, reject) => {
        resolveAuth = resolve;
        rejectAuth = reject;
        ensureSilentIFrameExists();
        silentIframe.src = challengeUrl; 
    });
};

const challengeFb = (isRerequest) => {
    const popUpUrl = `${accountBaseUrl}/api/challenge?provider=FB${isRerequest?'&rerequest=true':''}&returnUrl=${encodeURIComponent(location.origin + fbRedirectUrl)}`;
    return challenge(popUpUrl, 'fb');
};

const challengeGoogle = () => {
    const popUpUrl = `${accountBaseUrl}/api/challenge?provider=GOOGLE&returnUrl=${encodeURIComponent(location.origin + fbRedirectUrl)}`;
    return challenge(popUpUrl, 'Google');
};

const challenge = (popUpUrl, popupTitel) => {
    return new Promise((resolve, reject) => {
        resolveAuth = resolve;
        rejectAuth = reject;
        if (popupWindow) popupWindow.close();
        const params = 'scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=600,height=400,left=100,top=100';
        popupWindow = window.open(popUpUrl, popupTitel, params);
    })
    .then(() => isLoggedInAuthority())
    .then(isLogged => {
        if (isLogged) {
            return ensureClientsAuthenticated(new Promise(r => r()));
        }
    });
}

const getExternalUserInfo = () => {
    return ax.get('external/userinfo')
        .then(res => res.data)
        .catch(() => fail('TgLogin.getExternalUserInfo: Backend error'));
};

const signOut = () => {
    eraseHint();
    return new Promise((resolve, reject) => {
        resolveAuth = () => {
            ax.post('signout')
                .then(() => mgr.removeUser())
                .then(() => postSignOutHook())
                .then(() => resolve())
                .catch(() => reject({
                    errorCode: 0,
                    errorMessage: 'TgLogin.signOut: Backend error'
                }));
        };
        ensureSilentIFrameExists();
        silentIframe.src = signOutUrl;
    });
};

const signIn = ({email, password}) => {
    return ensureClientsAuthenticated(ax.post('signin', {email, password})
        .then(res => res.data)
        .catch(res => {
            if (res.response.status === 400 && res.response.data.errorCode) {
                return failWithBackend(res.response.data);
            }
            else {
                return fail('TgLogin.signIn: Backend error')
            }
        }));
};

const authBackendAndFrontend = () => {
    const beAuth = silentRefresh();
    const feAuth = mgr.signinSilent();
    return Promise.all([beAuth, feAuth]);
};

const ensureClientsAuthenticated = (authPromise) => {
    const authStep = authPromise
        .then(() => authBackendAndFrontend())
        .then(() => {
            var hint = ensureHintExists();
            var postLogin = axios.post(subfolder + '/api/account/postlogin').then((data) => postLoginHook(data));
            return Promise.all([hint, postLogin]);
        });

    return Promise.all([authPromise, authStep]).then(([result]) => result).catch(data => data);
};

const signUpInternal = ({url, email, password, firstName, lastName, isSendNews, referallId}) => {
    return ensureClientsAuthenticated(ax.post(url, {
            email,
            password,
            firstName,
            lastName,
            isSubscribedToNewsletter: isSendNews,
            siteId,
            referralId: referallId
        })
        .then(res => res.data)
        .catch(res => {
            if (res.response.status === 400 && res.response.data.errorCode) {
                return failWithBackend(res.response.data);
            }
            else {
                return fail('TgLogin.signUpInternal: Backend error')
            }
        }));
};

const signUp = (data) => {
    return signUpInternal({url: 'signup', ...data});
};

const signUpExternal = (data) => {
    return signUpInternal({url: 'external/signup', ...data});
}

const silentCallback = () => {
    (window.opener || window.parent).postMessage(window.location.href, location.origin);
}

const forgotPassword = ({email, returnUrl}) => {
    return ax.post('forgot_password', {email, absoluteReturnUrl: returnUrl})
        .then(res => res.data)
        .catch(res => {
            if (res.response.status === 400 && res.response.data.errorCode) {
                return failWithBackend(res.response.data);
            }
            else {
                return fail('TgLogin.forgotPassword: Backend error')
            }
        });
};

const validateForgotPassword = ({accountId, token}) => {
    return ax.post('forgot_password/token/validate', {accountId, token})
        .then(res => res.data)
        .catch(res => {
            if (res.response.status === 400 && res.response.data.errorCode) {
                return failWithBackend(res.response.data);
            }
            else {
                return fail('TgLogin.validateForgotPassword: Backend error')
            }
        });
};

const resetForgottenPassword = ({accountId, token, password}) => {
    return ax.post('forgot_password/reset', {accountId, token, password})
        .then(res => res.data)
        .catch(res => {
            if (res.response.status === 400 && res.response.data.errorCode) {
                return failWithBackend(res.response.data);
            }
            else {
                return fail('TgLogin.resetForgottenPassword: Backend error')
            }
        });
};

const getUser = () => {
    return mgr.getUser().then(res => ({
        access_token: res.access_token,
        profile: res.profile
    }));
};

const forceUserUpdate = () => {
    return mgr.signinSilent().then(() => ensureHintExists(true)).then(() => getUser());
};

window.TgLogin = {
    'internal_do_not_use': {
        silentRefresh,
        oidcUserManager: mgr,
        silentCallback
    },
    errorCodes: {
        invalidCreds: 100,
        accountAlreadyExists: 200,
        accountValidationFailed: 300,
        accountNotFound: 400,
        tokenNotValid: 500
    },
    isLoggedIn,
    challengeFb,
    challengeGoogle,
    getExternalUserInfo,
    signIn,
    signUp,
    signUpExternal,
    signOut,
    getUser,
    forceUserUpdate,
    forgotPassword,
    validateForgotPassword,
    resetForgottenPassword
};
